import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';
import FeedbackMandou from 'assets/img/comportamento/mandou.svg';
import { getUserNotifications } from 'services/notifications.service';
import ModalAcessivel from 'components/modal-acessivel';
import { readOncePerSession, SESSION_KEYS, setSessionValue } from 'utils/session-reads';

import Bandeira from '../../assets/img/festa-junina/bandeiras.gif';
import Fita from '../../assets/img/festa-junina/fita.svg';

export default function Notification() {
  const [notification, setNotification] = useState<any>();
  const [allNotification, setAllNotification] = useState<any>([]);

  const { user } = useAuth();
  const userId = user?._id;

  async function handleClose() {
    if (allNotification?.length > 1) {
      const data = [...allNotification];
      setNotification(data[1]);
      const newData = data.slice(1);
      setAllNotification(newData);
      if (userId) setSessionValue(SESSION_KEYS.userNotifications(userId), newData);
    } else {
      setNotification(null);
      setAllNotification([]);
      // Fechada, fica fechada até F5/login (DCE-38).
      if (userId) setSessionValue(SESSION_KEYS.userNotifications(userId), null);
    }
  }

  // `notification?...&delete=true` apaga no servidor ao ler: 1 vez por sessão por player (DCE-37).
  useEffect(() => {
    if (!userId) return;

    let active = true;

    readOncePerSession(SESSION_KEYS.userNotifications(userId), getUserNotifications)
      .then(notifications => {
        if (active && notifications?.[0]) {
          setNotification(notifications[0]);
          // Comportamento anterior mantido: grava o estado ainda vazio, então só a primeira aparece.
          setAllNotification(notification);
        }
      })
      .catch(error => console.error('Erro ao carregar notificações do player:', error));

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (!notification) return null;

  return (
    <ModalAcessivel isOpen={notification} onRequestClose={() => handleClose()}>
      <div className="modal-news fixed bg-black bg-opacity-80 top-0 left-0 w-screen h-screen p-6 pt-[10vh] flex justify-center overflow-y-auto z-40">
        <div className="relative border-2 border-solid border-electric-blue bg-oxford-blue rounded-2xl p-10 max-w-[500px] h-fit">
          <Button
            color="primary"
            className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
            onClick={() => handleClose()}
            arialabel="Fechar modal"
          >
            <IoIosClose color="white" size={30} />
          </Button>

          <div className='className="flex flex-col items-center justify-center text-center'>
            {notification?.item?.name === 'Envie um Correio de Elogio' && (
              <img
                className="hidden md:block absolute top-0 right-0 z-10 -scale-x-100 select-none pointer-events-none"
                src={Bandeira}
                alt="Imagem de uma bandeira de festa junina"
              />
            )}

            <div className="flex items-center justify-center mb-6">
              <img src={FeedbackMandou} alt="Imagem de feedback" className="w-[173px] block" />
            </div>
            {notification?.definition?.content !== 'rede' ? (
              <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center">
                uhul! {notification?.item?.name} concluído
              </h1>
            ) : (
              <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center">uhul! Você concluiu a ação:</h1>
            )}

            {notification?.definition?.content !== 'rede' ? (
              <p className="text-center">{notification?.definition?.content}</p>
            ) : (
              <p className="text-center">{notification?.item?.name}</p>
            )}
          </div>
        </div>
      </div>
    </ModalAcessivel>
  );
}
